
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casestudy",
      function () {
        return require("private-next-pages/casestudy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casestudy"])
      });
    }
  